import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { InstrumentDetailsLinkComponent, WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { Asset, InstrumentType } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { SavingPlanSearchComponent } from '../saving-plan-search/saving-plan-search.component';

@Component({
  selector: 'saving-plans-saving-plan-subjects',
  templateUrl: './saving-plan-subjects.component.html',
  imports: [AsyncPipe, SavingPlanSearchComponent, InstrumentDetailsLinkComponent, WatchlistToggleComponent, RouterLink, TranslocoPipe],
})
export class SavingPlanSubjectsComponent {
  public readonly facade = inject(SavingsPlanFacade);
  public readonly savingPlanMaskUrl = commonRoutes.postlogin.add_savings_plan;
  public readonly orderMaskUrl = commonRoutes.postlogin.buyAndSell;
  public readonly types = [InstrumentType.Etf, InstrumentType.Funds, InstrumentType.Share, InstrumentType.Crypto];
  public readonly instrumentType = InstrumentType;
  readonly #router = inject(Router);

  public useSavingsPlan = (asset: Asset) => this.#router.navigate([`${commonRoutes.postlogin.add_savings_plan}/${asset.isin}`]);
}
